"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HTMLUtils_1 = require("../../utils/HTMLUtils");
var SitecoreExperienceEditor = (function () {
    function SitecoreExperienceEditor() {
        this.isOverriden = false;
        this.onAfterFrameLoadedCallbacks = [];
    }
    SitecoreExperienceEditor.prototype.registerOnLoadRenderingFromUrl = function (onAfterFrameLoadedCallback) {
        this.overrideSitecoreLoadRenderingFromUrl();
        this.onAfterFrameLoadedCallbacks.push(onAfterFrameLoadedCallback);
    };
    SitecoreExperienceEditor.prototype.isInBackgroundRendering = function () {
        return window.location.search.indexOf(SitecoreExperienceEditor.isInBackgroundRenderingParameterName) !== -1;
    };
    SitecoreExperienceEditor.prototype.getComponentFromLoadRenderingFromUrlCallbackData = function (callbackData) {
        if (!callbackData.renderingElement) {
            console.error("Could not find the rendering element from Sitecore callback data.", callbackData);
        }
        var chromeRendering = document.getElementById(callbackData.renderingElement.opening[0].id);
        return chromeRendering.nextElementSibling;
    };
    SitecoreExperienceEditor.prototype.overrideSitecoreLoadRenderingFromUrl = function () {
        var _this = this;
        if (!this.isOverriden && typeof (Sitecore) !== "undefined") {
            var originalLoad_1 = Sitecore.PageModes.ChromeTypes.Placeholder.prototype._loadRenderingFromUrl;
            var onAfterFrameLoadedCallback_1 = function (callbackData) {
                _this.onAfterFrameLoadedCallbacks.forEach(function (callback) { return callback(callbackData); });
            };
            Sitecore.PageModes.ChromeTypes.Placeholder.prototype._loadRenderingFromUrl = function (url, frameLoadedCallback) {
                originalLoad_1.call(this, url + "&" + SitecoreExperienceEditor.isInBackgroundRenderingParameterName + "=1", function (callbackData) {
                    frameLoadedCallback.call(this, callbackData);
                    onAfterFrameLoadedCallback_1(callbackData);
                });
            };
            this.isOverriden = true;
        }
    };
    SitecoreExperienceEditor.prototype.registerShowDebugInformationCallback = function () {
        if (!window["scCoveoShowDebugInformation"]) {
            window["scCoveoShowDebugInformation"] = function (debugModeEnabled) {
                var debugInfoElements = HTMLUtils_1.nodeListToArray(document.getElementsByClassName("coveo-debug-information"));
                if (debugModeEnabled) {
                    debugInfoElements.forEach(function (element) { return element.classList.remove("coveo-debug-hidden"); });
                }
                else {
                    debugInfoElements.forEach(function (element) { return element.classList.add("coveo-debug-hidden"); });
                }
                // Chromes are not updated correctly until an event refreshes them. This forces the update.
                Sitecore.PageModes.ChromeManager.resetChromes();
            };
        }
    };
    return SitecoreExperienceEditor;
}());
SitecoreExperienceEditor.isInBackgroundRenderingParameterName = "isInBackgroundRendering";
exports.SitecoreExperienceEditor = SitecoreExperienceEditor;
var staticInstance = new SitecoreExperienceEditor();
function getExperienceEditorInstance() {
    return staticInstance;
}
exports.getExperienceEditorInstance = getExperienceEditorInstance;



//////////////////
// WEBPACK FOOTER
// ./src/base/initialization/SitecoreExperienceEditor.ts
// module id = 9
// module chunks = 13 14